import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

import { CUSTOMER_PROFILE_SUB_NAVIGATION_ROUTES } from "./customer";
import { SLOTS_TABS, SLOTS_SUB_NAVIGATION_ROUTES } from "./slots";
import {
  ORDER_MANAGEMENT_SUB_NAV_ROUTES,
  ORDER_SUB_NAVIGATION_ROUTES,
  QC_ORDER_MANAGEMENT_SUB_NAV_ROUTES,
} from "./order";
import { APPOINTMENTS_SUB_NAVIGATION_ROUTES, ROTA_SUB_NAVIGATION_ROUTES } from "./appointments";
import {
  CONFIGURATION_SUB_NAVIGATION_ROUTES,
  SERVICE_DESK_SUB_NAVIGATION_ROUTES,
  COUPON_SERVICE_SUB_NAVIGATION_ROUTES,
  MEMBERSHIP_SETUP_SUB_NAVIGATION_ROUTES,
  MEMBERSHIP_EXTENSION_SUB_NAVIGATION_ROUTES,
  VOUCHER_SETUP_SUB_NAVIGATION_ROUTES,
  GIFT_SETUP_SUB_NAVIGATION_ROUTES,
  DATA_MAPPINGS_SUB_NAV_ROUTES,
  WHITELIST_MOBILE_SUB_NAV_ROUTES,
  TILES_PAGE_SUB_NAV_ROUTES,
} from "./configuration";
import { INVENTORY_SUB_NAVIGATION_ROUTES } from "./inventory";
import { DAY_CLOSING_SUB_NAVIGATION_ROUTES, ACCOUNTING_SUB_NAVIGATION_ROUTES } from "./accounting";
import {
  PATIENT_WAITING_LIST_SUB_NAV_ROUTES,
  AT_HOME_SERVICES_SUB_NAV_ROUTES,
  STAFF_CALENDAR_SUB_NAV_ROUTES,
} from "./pwl";
import { CART_MANAGEMENT_SUB_NAV_ROUTES } from "./cart";
import {
  LAB_REPORT_SUB_NAVIGATION_ROUTES,
  CLINIC_LAB_REPORT_SUB_NAVIGATION_ROUTES,
  LAB_REPORT_INTERPRETATION_SUB_NAVIGATION_ROUTES,
} from "./lab-report";

export const NAVIGATION_ROUTES: IRoutesDefined = {
  VMS_SETUP: {
    id: "VMS_SETUP",
    title: "VMS Setup",
    icon: "",
    url: "/app/vms-setup",
    path: "vms-setup",
    children: {},
  },
  MAPPED_CLINIC_AND_CITY: {
    id: "MAPPED_CLINIC_AND_CITY",
    title: "Mapped Clinic",
    icon: "HiOutlineHome",
    url: "/app/map-clinic-and-city",
    path: "map-clinic-and-city",
    children: {},
  },
  INVALID_ACCESS: {
    id: "INVALID_ACCESS",
    title: "Invalid Access",
    icon: "HiOutlineHome",
    url: "/app/invalid-access",
    path: "invalid-access",
    children: {},
  },
  INVALID_LOGIN: {
    id: "INVALID_LOGIN",
    title: "Invalid Login",
    icon: "HiOutlineHome",
    url: "/app/invalid-login",
    path: "invalid-login",
    children: {},
  },
  CALL_ANALYSIS: {
    id: "CALL_ANALYSIS",
    title: "Call Analysis",
    icon: "",
    url: "/app/tools/call-analysis",
    path: "tools/call-analysis",
    children: {},
  },
  VETIC_EMBED: {
    id: "VETIC_EMBED",
    title: "Vetic Embed",
    icon: "",
    url: "/app/vetic-embed",
    path: "vetic-embed",
    children: {},
  },
  DASHBOARD: {
    id: "DASHBOARD",
    title: "dashboard",
    icon: "MdOutlineDashboard",
    url: "/app/dashboard",
    path: "dashboard",
    children: {},
  },
  CUSTOMER_PROFILE: {
    id: "CUSTOMER_PROFILE",
    title: "customer_profile",
    icon: "HiOutlineUserCircle",
    url: "",
    path: "customer/profile",
    children: {
      ...CUSTOMER_PROFILE_SUB_NAVIGATION_ROUTES,
    },
  },

  APPOINTMENTS: {
    id: "APPOINTMENTS",
    title: "Appointments",
    icon: "MdOutlineLibraryBooks",
    url: "",
    path: "/app/appointment",
    children: {
      ...APPOINTMENTS_SUB_NAVIGATION_ROUTES,
    },
  },
  ROTA: {
    id: "ROTA",
    title: "Rota",
    icon: "HiOutlineUserCircle",
    url: "/app/rota",
    path: "rota",
    children: {
      ...ROTA_SUB_NAVIGATION_ROUTES,
    },
  },
  SLOTS: {
    id: "SLOTS",
    title: "slots",
    icon: "BsUiChecksGrid",
    path: "slots",
    RBACDisplayName: "BOOKINGS",
    url: "/app/slots",
    children: {
      ...SLOTS_SUB_NAVIGATION_ROUTES,
      ...SLOTS_TABS,
    },
  },
  PATIENT_WAITING_LIST: {
    id: "PATIENT_WAITING_LIST",
    title: "patient_waiting_list",
    icon: "PiUserListLight",
    path: "patient-waiting-list",
    url: "/app/patient-waiting-list",
    children: {
      ...PATIENT_WAITING_LIST_SUB_NAV_ROUTES,
    },
  },
  AT_HOME_SERVICES: {
    id: "AT_HOME_SERVICES",
    title: "at_home_services",
    icon: "PiUserListLight",
    path: "at-home-services",
    url: "/app/at-home-services",
    children: {
      ...AT_HOME_SERVICES_SUB_NAV_ROUTES,
    },
  },
  STAFF_CALENDAR: {
    id: "STAFF_CALENDAR",
    title: "Staff_Calender",
    icon: "HiOutlineUserCircle",
    path: "staff-calendar",
    url: "/app/staff-calendar",
    children: {
      ...STAFF_CALENDAR_SUB_NAV_ROUTES,
    },
  },
  ORDER_MANAGEMENT: {
    id: "ORDER_MANAGEMENT",
    title: "order_management",
    icon: "BsCardChecklist",
    path: "qc-orders",
    url: "/app/qc-orders",
    children: {
      ...ORDER_MANAGEMENT_SUB_NAV_ROUTES,
      ...ORDER_SUB_NAVIGATION_ROUTES,
    },
  },
  CART_MANAGEMENT: {
    id: "CART_MANAGEMENT",
    title: "cart_management",
    icon: "BsCardChecklist",
    path: "user-cart",
    url: "/app/user-cart",
    children: {
      ...CART_MANAGEMENT_SUB_NAV_ROUTES,
    },
  },
  QC_TRANSFER_ORDER: {
    id: "QC_TRANSFER_ORDER",
    title: "QC & TC Orders",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "QC & TC Orders",
    icon: "BsCardChecklist",
    path: "qc-transfer-order",
    url: "/app/qc-transfer-order",
    isVirtual: true,
    children: {
      ...QC_ORDER_MANAGEMENT_SUB_NAV_ROUTES,
    },
  },
  CONFIGURATION: {
    id: "CONFIGURATION",
    title: "Configuration",
    icon: "BsCardChecklist",
    path: "configuration",
    url: "/app/configuration",
    children: {
      ...CONFIGURATION_SUB_NAVIGATION_ROUTES,
    },
  },
  SERVICE_DESK: {
    id: "SERVICE_DESK",
    title: "service desk",
    icon: "BsCardChecklist",
    path: "service-desk",
    url: "/app/service-desk",
    children: {
      ...SERVICE_DESK_SUB_NAVIGATION_ROUTES,
    },
  },
  COUPON_SERVICE: {
    id: "COUPON_SERVICE",
    title: "COUPON SERVICE",
    icon: "BsCardChecklist",
    path: "coupon-service",
    url: "/app/coupon-service",
    children: {
      ...COUPON_SERVICE_SUB_NAVIGATION_ROUTES,
    },
  },
  MEMBERSHIP_SETUP: {
    id: "MEMBERSHIP_SETUP",
    title: "MEMBERSHIP SETUP",
    icon: "BsCardChecklist",
    path: "membership-setup",
    url: "/app/membership-setup",
    children: {
      ...MEMBERSHIP_SETUP_SUB_NAVIGATION_ROUTES,
    },
  },
  MEMBERSHIP_EXTENSION: {
    id: "MEMBERSHIP_EXTENSION",
    title: "MEMBERSHIP EXTENSION SETUP",
    icon: "BsCardChecklist",
    path: "membership-extension",
    url: "/app/membership-extension",
    children: {
      ...MEMBERSHIP_EXTENSION_SUB_NAVIGATION_ROUTES,
    },
  },
  VOUCHER_SETUP: {
    id: "VOUCHER_SETUP",
    title: "VOUCHER SETUP",
    icon: "BsCardChecklist",
    path: "voucher-setup",
    url: "/app/voucher-setup",
    children: {
      ...VOUCHER_SETUP_SUB_NAVIGATION_ROUTES,
    },
  },
  GIFT_SETUP: {
    id: "GIFT_SETUP",
    title: "GIFT SETUP",
    icon: "BsCardChecklist",
    path: "gift-setup",
    url: "/app/gift-setup",
    children: {
      ...GIFT_SETUP_SUB_NAVIGATION_ROUTES,
    },
  },

  ACCOUNTING: {
    id: "ACCOUNTING",
    title: "Accounting",
    icon: "HiOutlineUserCircle",
    url: "",
    path: "accounting",
    children: {
      ...ACCOUNTING_SUB_NAVIGATION_ROUTES,
    },
  },
  DAY_CLOSING: {
    id: "DAY_CLOSING",
    title: "Day Closing",
    icon: "HiOutlineUserCircle",
    url: "/app/closing/day-closing",
    path: "closing",
    children: {
      ...DAY_CLOSING_SUB_NAVIGATION_ROUTES,
    },
  },
  LAB_REPORT: {
    id: "LAB_REPORT",
    title: "Lab Report",
    icon: "HiOutlineUserCircle",
    url: "/app/lab-report/internal",
    path: "lab-report",
    children: {
      ...LAB_REPORT_SUB_NAVIGATION_ROUTES,
    },
  },
  LAB_REPORT_INTERPRETATION: {
    id: "LAB_REPORT_INTERPRETATION",
    title: "Lab Report Interpretation",
    RBACDisplayName: "LAB_REPORT_INTERPRETATION",
    icon: "HiOutlineUserCircle",
    url: "/app/lab-report-interpretation/list",
    path: "lab-report-interpretation",
    children: {
      ...LAB_REPORT_INTERPRETATION_SUB_NAVIGATION_ROUTES,
    },
  },

  INVENTORY: {
    id: "INVENTORY",
    title: "Inventory",
    icon: "HiOutlineUserCircle",
    url: "",
    path: "inventory",
    children: {
      ...INVENTORY_SUB_NAVIGATION_ROUTES,
    },
  },
  WHITELIST_MOBILE: {
    id: "WHITELIST_MOBILE",
    title: "Whitelist Mobile",
    icon: "HiOutlineUserCircle",
    url: "/app/whitelist-mobile",
    path: "whitelist-mobile",
    children: {
      ...WHITELIST_MOBILE_SUB_NAV_ROUTES,
    },
  },
  CLINIC_LAB_REPORT: {
    id: "CLINIC_LAB_REPORT",
    title: "Clinic Lab Report",
    icon: "HiOutlineUserCircle",
    url: "/app/clinic-lab-report",
    path: "clinic-lab-report",
    children: {
      ...CLINIC_LAB_REPORT_SUB_NAVIGATION_ROUTES,
    },
  },
  DATA_MAPPINGS: {
    id: "DATA_MAPPINGS",
    title: "Data Mappings",
    icon: "HiOutlineUserCircle",
    url: "/app/mappings",
    path: "mappings",
    children: {
      ...DATA_MAPPINGS_SUB_NAV_ROUTES,
    },
  },
  TILES_PAGE: {
    id: "TILES_PAGE",
    title: "Tiles",
    icon: "HiOutlineUserCircle",
    url: "/app/tiles",
    path: "tiles",
    children: {
      ...TILES_PAGE_SUB_NAV_ROUTES,
    },
  },
};

export const ROUTES: IRoutesDefined = {
  LANDING_PAGE: {
    id: "LANDING_PAGE",
    icon: "HiOutlineHome",
    title: "Vetic VMS Product",
    description: "Vetic VMS Product",
    url: "/",
    path: "/",
    children: {},
  },

  ROOT: {
    id: "ROOT",
    icon: "HiOutlineHome",
    title: "Vetic VMS",
    description: "Vetic VMS Description about the application",
    url: "/app",
    path: "/app", // path is basically path to the children in the nested routes
    children: {
      ...NAVIGATION_ROUTES, // rendering navigation routes inside main /app route
    },
  },
  LOGOUT_PAGE: {
    id: "LOGOUT_PAGE",
    title: "",
    icon: "",
    path: "/logout",
    url: "/app/logout",
    children: {},
  },
  LOGIN_PAGE: {
    id: "LOGIN_PAGE",
    title: "Vetic VMS Login",
    icon: "HiOutlineHome",
    description: "Vetic VMS Login Page",
    url: "/app/login",
    path: "/login",
    children: {},
  },
  CALL_ANALYSIS: {
    id: "CALL_ANALYSIS",
    title: "Call Analysis",
    icon: "",
    url: "/app/tools/call-analysis",
    path: "tools/call-analysis",
    children: {},
  },
};
